import { CommonProp, IconButton, IconDelete } from '@acin/ui-core';
import React from 'react';
import { IInternalRegulationObligationRuleReviewStatus } from '../../../graphql/generated';
import * as SC from './RuleItem.styled';

export interface RuleItemProps extends CommonProp {
  id?: string;
  name?: string | null;
  reviewStatus?: IInternalRegulationObligationRuleReviewStatus | null;
  onDelete?: (id: string) => void;
  onSelect?: (id: string) => void;
  isActive?: boolean;
}

export const RuleItem: React.FC<RuleItemProps> = ({ id, name, reviewStatus, onDelete, onSelect, isActive }) => {
  const handleDelete = () => {
    if (id && onDelete) {
      onDelete(id);
    }
  };

  const handleSelect = () => {
    if (id && onSelect) {
      onSelect(id);
    }
  };

  return (
    <SC.RuleItemBox onClick={handleSelect} isActive={!!isActive} reviewStatus={reviewStatus}>
      <SC.Name>{name}</SC.Name>
      <SC.DeleteButtonWrapper>
        <IconButton size="small" label="Delete" onClick={handleDelete} icon={() => <IconDelete />} />
      </SC.DeleteButtonWrapper>
    </SC.RuleItemBox>
  );
};
